"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var overview_content_field_model_1 = require("../../../../common/model/overview-content-field.model");
var overview_field_type_1 = require("../../../../common/model/overview-field-type");
var overview_card_type_1 = require("../../../../common/model/overview-card-type");
var config_constants_1 = require("../../../../common/constants/config-constants");
var overview_aggregate_dialog_component_1 = require("../overview-aggregate-dialogs/overview-aggregate-dialog.component");
var overview_custom_component_dialog_component_1 = require("../overview-custom-component-dialog/overview-custom-component-dialog.component");
/**
 * Component for showing single portfolio column/overview card field.
 */
var OverviewSingleFieldConfigComponent = /** @class */ (function () {
    function OverviewSingleFieldConfigComponent(dialog, cdRef) {
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.acceptableOverviewFieldTypes = [];
        this.entityFieldsList = [];
        this.isPortfolioField = false;
        this.fieldValueChange = new core_1.EventEmitter();
        this.OverviewCardType = overview_card_type_1.OverviewCardType;
        this.OverviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType;
    }
    OverviewSingleFieldConfigComponent.prototype.ngOnInit = function () {
        this.setOverviewFieldTypeMessage();
    };
    OverviewSingleFieldConfigComponent.prototype.ngOnChanges = function (changes) {
        if ('field' in changes) {
            this.setOverviewFieldTypeMessage();
        }
    };
    OverviewSingleFieldConfigComponent.prototype.setOverviewFieldTypeMessage = function () {
        var _this = this;
        this.fieldTypeMessage = this.field.overviewPortfolioFieldType &&
            config_constants_1.OVERVIEW_PORTFOLIO_FIELD_TYPES.find(function (type) { return type.id === _this.field.overviewPortfolioFieldType; }).messageKey;
    };
    OverviewSingleFieldConfigComponent.prototype.openAggregateDialog = function (item) {
        var _this = this;
        var dialogConfig = overview_aggregate_dialog_component_1.OverviewAggregateDialogComponent.getDialogConfig();
        dialogConfig.data = {
            category: this.category,
            rootCategory: this.rootCategory,
            cardType: this.cardType,
            aggregateConfig: item && item.aggregateConfig,
            isPortfolioField: this.isPortfolioField
        };
        this.dialog.open(overview_aggregate_dialog_component_1.OverviewAggregateDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (result) {
            if (result) {
                item.aggregateConfig = null;
                _this.cdRef.markForCheck();
                // to update pipe values without making it not pure
                setTimeout(function () {
                    item.aggregateConfig = result;
                    item.fieldName = item.aggregateConfig.aggregateFunction;
                    item.overviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE;
                    _this.setOverviewFieldTypeMessage();
                    _this.fieldValueChange.emit();
                    _this.cdRef.markForCheck();
                }, 0);
            }
        });
    };
    OverviewSingleFieldConfigComponent.prototype.openCustomComponentDialogComponent = function (item) {
        var _this = this;
        var dialogConfig = overview_custom_component_dialog_component_1.OverviewCustomComponentDialogComponent.getDialogConfig();
        dialogConfig.data = {
            category: this.category,
            rootCategory: this.rootCategory,
            cardType: this.cardType,
            isPortfolioField: this.isPortfolioField,
            selectedFieldName: item && item.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT ? item.fieldName : null
        };
        this.dialog.open(overview_custom_component_dialog_component_1.OverviewCustomComponentDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (result) {
            if (result) {
                item.fieldName = null;
                item.overviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType.COMPONENT;
                _this.setOverviewFieldTypeMessage();
                _this.cdRef.markForCheck();
                // to update pipe values without making it not pure
                setTimeout(function () {
                    item.fieldName = result;
                    _this.fieldValueChange.emit();
                    _this.cdRef.markForCheck();
                });
            }
        });
    };
    OverviewSingleFieldConfigComponent.prototype.changeFieldTypeField = function (overviewPortfolioFieldType, item) {
        if (overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE) {
            this.openAggregateDialog(item);
        }
        else if (overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT) {
            item.aggregateConfig = null;
            this.openCustomComponentDialogComponent(item);
        }
        else if (overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.FIELD || overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.CALCULATION) {
            item.aggregateConfig = null;
            item.fieldName = null;
            item.overviewPortfolioFieldType = overviewPortfolioFieldType;
            this.setOverviewFieldTypeMessage();
            this.fieldValueChange.emit();
            this.cdRef.markForCheck();
        }
    };
    OverviewSingleFieldConfigComponent.prototype.changeFieldValue = function (fieldValue) {
        this.field.fieldName = fieldValue;
        this.fieldValueChange.emit();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], OverviewSingleFieldConfigComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", overview_content_field_model_1.OverviewContentPortfolioFieldModel)
    ], OverviewSingleFieldConfigComponent.prototype, "field", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], OverviewSingleFieldConfigComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], OverviewSingleFieldConfigComponent.prototype, "rootCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], OverviewSingleFieldConfigComponent.prototype, "acceptableOverviewFieldTypes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], OverviewSingleFieldConfigComponent.prototype, "entityFieldsList", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], OverviewSingleFieldConfigComponent.prototype, "cardType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], OverviewSingleFieldConfigComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], OverviewSingleFieldConfigComponent.prototype, "customFields$", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], OverviewSingleFieldConfigComponent.prototype, "isPortfolioField", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], OverviewSingleFieldConfigComponent.prototype, "fieldValueChange", void 0);
    OverviewSingleFieldConfigComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-overview-single-field-config',
            styles: [require('./overview-single-field-config.component.css')],
            template: require('./overview-single-field-config.component.html'),
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            core_1.ChangeDetectorRef])
    ], OverviewSingleFieldConfigComponent);
    return OverviewSingleFieldConfigComponent;
}());
exports.OverviewSingleFieldConfigComponent = OverviewSingleFieldConfigComponent;
//# sourceMappingURL=overview-single-field-config.component.js.map